/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyIntel
 */
export interface CompanyIntel {
  /**
   *
   * @type {string}
   * @memberof CompanyIntel
   */
  companyIntelId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyIntel
   */
  companyId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  blockers?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  pricingSentiment?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  pricingImprovements?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  keyDecisionMakers?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  currentSolutions?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  concreteNextSteps?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  otherPotentialNextSteps?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  integrationNeeds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  closingLikeliness?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  closingTimeline?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CompanyIntel
   */
  seasonality?: Array<string>;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyIntel
   */
  generatedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the CompanyIntel interface.
 */
export function instanceOfCompanyIntel(value: object): value is CompanyIntel {
  return true;
}

export function CompanyIntelFromJSON(json: any): CompanyIntel {
  return CompanyIntelFromJSONTyped(json, false);
}

export function CompanyIntelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyIntel {
  if (json == null) {
    return json;
  }
  return {
    companyIntelId:
      json["companyIntelId"] == null ? undefined : json["companyIntelId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    blockers: json["blockers"] == null ? undefined : json["blockers"],
    pricingSentiment:
      json["pricingSentiment"] == null ? undefined : json["pricingSentiment"],
    pricingImprovements:
      json["pricingImprovements"] == null
        ? undefined
        : json["pricingImprovements"],
    keyDecisionMakers:
      json["keyDecisionMakers"] == null ? undefined : json["keyDecisionMakers"],
    currentSolutions:
      json["currentSolutions"] == null ? undefined : json["currentSolutions"],
    concreteNextSteps:
      json["concreteNextSteps"] == null ? undefined : json["concreteNextSteps"],
    otherPotentialNextSteps:
      json["otherPotentialNextSteps"] == null
        ? undefined
        : json["otherPotentialNextSteps"],
    integrationNeeds:
      json["integrationNeeds"] == null ? undefined : json["integrationNeeds"],
    closingLikeliness:
      json["closingLikeliness"] == null ? undefined : json["closingLikeliness"],
    closingTimeline:
      json["closingTimeline"] == null ? undefined : json["closingTimeline"],
    seasonality: json["seasonality"] == null ? undefined : json["seasonality"],
    generatedAt: json["generatedAt"] == null ? undefined : json["generatedAt"],
  };
}

export function CompanyIntelToJSON(json: any): CompanyIntel {
  return CompanyIntelToJSONTyped(json, false);
}

export function CompanyIntelToJSONTyped(
  value?: CompanyIntel | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyIntelId: value["companyIntelId"],
    companyId: value["companyId"],
    blockers: value["blockers"],
    pricingSentiment: value["pricingSentiment"],
    pricingImprovements: value["pricingImprovements"],
    keyDecisionMakers: value["keyDecisionMakers"],
    currentSolutions: value["currentSolutions"],
    concreteNextSteps: value["concreteNextSteps"],
    otherPotentialNextSteps: value["otherPotentialNextSteps"],
    integrationNeeds: value["integrationNeeds"],
    closingLikeliness: value["closingLikeliness"],
    closingTimeline: value["closingTimeline"],
    seasonality: value["seasonality"],
    generatedAt: value["generatedAt"],
  };
}
